module.exports = __webpack_public_path__ + "static/img/header-lightbox-ocean.a93a46f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/header-lightbox-ocean.jpg
// module id = jwxb
// module chunks = 1